export const DEFAULT_HIDE_ACCOUNT_VALUE: boolean = true;
export const DEFAULT_STRIPE_INITIALIZE_AMOUNT: number = 699;
export const DESKTOP_HEADER_HEIGHT = 60;
export const DESKTOP_HEADER_HEIGHT_WITH_TOP_MESSAGE = 100;
export const MOBILE_HEADER_HEIGHT = 74;
export const DESKTOP_TOP_MESSAGE_HEIGHT = 40;
export const DESKTOP_PRODUCT_LIST_FILTER_HEIGHT = 44;
export const DESKTOP_SECTION_NAV_HEIGHT = 40;
export const WAIT_FOR_NAVIGATION_TIMEOUT = 5000;
export const WAIT_FOR_NAVIGATION_INTERVAL = 100;
export const MOBILE_CARDS_PER_ROW = 2;
export const GTM_EVENT_TIMEOUT = 2000;
export const UPLOAD_MAX_RETRIES = 3;
export const UPLOAD_INITIAL_DELAY_MS = 500;
export const HOME_BUTTON_TEXT = 'Home';
export const SEARCH_BUTTON_TEXT = 'Or search for products';
export const VALID_ASSET_FORMATS = ['webp', 'avif', 'jpg', 'jpeg', 'png'];
export const MAX_VISIBLE_PAYMENT_ICONS = 16;
export const HIDDEN_PROVINCE_REGIONS: string[] = [];
export const UPLOAD_IMAGE_TIMEOUT_MS = 20000;
export const CLEAN_ACTIVE_ORDER_ID_TIMEOUT_MS = 5000;
export const NON_SUPPORTED_REGIONS_WARNING = 'Sorry, we couldn’t find a shipping option for your order. This may be because we don’t yet ship to your location or some items in your cart can’t be shipped there.';
export const DELIVERY_INFO_NOT_CONFIRMED_ERROR = 'Delivery information must be confirmed. Please click “Save & Continue” in the Delivery section.';
export const DELIVERY_INFO_INCOMPLETE_ERROR = 'Delivery information incomplete.';
export const FALLBACK_ASSET_URL = 'assets/fallback-asset.png';
export const FALLBACK_ICON_URL = 'assets/favicon.ico';
export const FALLBACK_APPLE_TOUCH_ICON_URL = 'assets/apple-touch-icon.png';
export const DEFAULT_LANGUAGE = 'en';